module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/User-898f25aaaf7fb1120c78f1bc3180ced3.svg";